import { createApp } from 'vue'
import App from './App.vue'
import '../src/vue/reader.css'
import './demo.css'

createApp(App).mount('#app')
